import { render, staticRenderFns } from "./WarningStatic.vue?vue&type=template&id=7bfca0b5"
import script from "./WarningStatic.vue?vue&type=script&lang=js"
export * from "./WarningStatic.vue?vue&type=script&lang=js"
import style0 from "./WarningStatic.vue?vue&type=style&index=0&id=7bfca0b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports